module.exports = __webpack_public_path__ + "img/u938.0f3839a6.png";